export default "__VITE_ASSET__kFuz9_SO__"